import styles from "../AstroStaticPage.module.scss";
import { AstroCardData } from "@/types/common.types";
import Image from "next/image";
import { ChingariButton } from "chingari-components";
import { useState } from "react";
import { useRouter } from "next/navigation";

const AstroCard = (card: AstroCardData) => {
  const router = useRouter();
  const [more, setMore] = useState(false);

  return (
    <div className={styles.card}>
      <div className={styles.titleWrapper}>
        {card?.image && (
          <Image src={card?.image} alt="img" width={60} height={60} />
        )}
        <h3>{card.title}</h3>
      </div>
      <p className={`${more ? styles.expand : ""}`}>{card.description}</p>
      {card.title !== "Frequently Asked Questions" && (
        <ChingariButton
          title={more ? "Less" : "More"}
          className={styles.button}
          onClick={() => {
            if (card?.moreLink) {
              router.push(card.moreLink);
            } else setMore((prev) => !prev);
          }}
        />
      )}
    </div>
  );
};

export default AstroCard;
